import React, { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { HelmetProvider } from 'react-helmet-async';
import { getWidgetConfigAsync } from '../apis/widget';

const TenantContext = createContext(null);

function useTenantHook() {
  const query = new URLSearchParams(window.location.search);
  const widgetKey = query.get('token');
  const [botName, setBotName] = useState("Kanis");
  const [roles, setRoles] = useState([]);
  const [closingMessage, setClosingMessage] = useState("Chat has ended");
  const [banner, setBanner] = useState("");
  const [logo, setLogo] = useState("");
  const [isConfigLoaded, setIsConfigLoaded] = useState(false);
  const [userRoleMessage, setUserRoleMessage] = useState("I am a...");

  useEffect(() => {
    async function fetchWidgetConfig() {
      if (!widgetKey) return;
      try {
        const { botName, closingMessage: configClosingMessage, roles, images, userRoleMessage } = await getWidgetConfigAsync(widgetKey);
        
        setRoles(roles ?? []);
        setBotName(botName);
        setClosingMessage(configClosingMessage);
        setUserRoleMessage(userRoleMessage ?? "I am a...");

        if (images) {
          if(images.logo) setLogo(images.logo.url);
          if(images.banner) setBanner(images.banner.url);
        }
        setIsConfigLoaded(true);
      } catch (e) {
        console.log(e);
      }
    }
    fetchWidgetConfig();
  }, [widgetKey])

  return {
    widgetKey,
    botName,
    closingMessage,
    roles,
    isConfigLoaded,
    theme: widgetKey ? `css/widget-${widgetKey}.css` : undefined,
    logo: logo,
    banner: banner,
    userRoleMessage
  };
}

export const useTenant = () => {
  const contextValue = useContext(TenantContext);
  if (contextValue === null) throw Error('TenantContext has not been Provided!');
  return contextValue;
};

export default function TenantProvider({ children }) {
  const tenant = useTenantHook();
  return (
    <TenantContext.Provider value={tenant}>
      <HelmetProvider>
        {children}
      </HelmetProvider>
    </TenantContext.Provider>
  );
}

TenantProvider.propTypes = {
  children: PropTypes.node,
};